// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12Sj5","signatureBlock":"Footer_signatureBlock__2IhQ1","signature":"Footer_signature__1HuJQ"};